import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { LucideAngularModule, type LucideIconData } from 'lucide-angular';

@Component({
  selector: 'app-info-line',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './info-line.component.html',
})
export class InfoLineComponent {
  icon = input.required<LucideIconData>();
  text = input.required<string>();
  additionalClasses = input<string>();
}
